/** Product is positioned for Indian MSMEs only (enterprise pathways hidden in UI). */
export const MSME_PRODUCT_FOCUS = true;

export const SIDEBAR_WORKSPACE_HEADING = 'CARBON WORKSPACE';
